var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeviceInfoList',{attrs:{"category":11,"title":'设备'}})}
var staticRenderFns = []

export { render, staticRenderFns }